import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { getTranslate } from 'react-localize-redux'
import history from '../../history'

import {
  postSendEmail
} from '../../redux/actions'

import ForgotForm from '../../components/forgot'

class ForgotPage extends Component {

  state = {
    complete: false
  }

  render() {

    const {
      translate,
      sendEmail
    } = this.props

    return (
      <ForgotForm
        translate={translate}
        sendEmail={sendEmail}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  complete: state.passwordresetReducer.complete,
  translate: getTranslate(state.localeReducer),
  ...state,
})

const mapDispatchToProps = (dispatch, props) => ({
  sendEmail: (email) => dispatch(postSendEmail(email))
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {

  if (stateProps.complete) {
    toast.info(stateProps.translate('password_reset_check_mail'), {
      position: toast.POSITION.TOP_CENTER,
      hideProgressBar: true,
    })
    history.replace('/login')
    stateProps.passwordresetReducer.complete = false
  }

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ForgotPage)
